import { IonCol, IonGrid, IonImg, IonLabel, IonPage, IonRow, IonText } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useBarcode } from 'react-barcodes';
import { RouteComponentProps } from 'react-router';

import Toolbar2 from '../../layouts/Toolbar2';
import { decodeString } from '../../library/Funcs';
import BackAppButton from './BackAppButton';

import './Payment.css';
import ActionButton from '../../components/button/ActionButton';

interface Props extends RouteComponentProps<{
  param1?: string,
  param2?: string,
  param3?: string,
  param4?: string,
  param5?: string,
  is_app?: string
}> { }

const Payment: React.FC<Props> = ({ match }) => {
  const [backAppDo, setBackAppDo] = useState("open" as any);

  const initBgWidth = 325
  const initBgHeight = 373

  const [bgSize, setBgSize] = useState({ width: "", height: "", left: "", top: "" });
  const [contentSize, setContentSize] = useState({ width: "", height: "", left: "", top: "" });
  const [text, setText] = useState({ for: "", title: "", description: "" });

  let { inputRef } = useBarcode({
    value: decodeString(match.params.param2),
    options: {
      displayValue: true,
      height: 30,
      fontSize: 12,
      background: "transparent",
      lineColor: "#444"
    }
  })

  useEffect(() => {
    const initTexts = () => {
      switch (match.params.param1) {
        case 'card':
          setBackAppDo("reload");

          setText({
            for: "صدور کارت",
            title: "هزینه صدور کارت با موفقیت پرداخت شد.",
            description: "مدارک شما بررسی خواهد شد و در صورت تأیید، کارت حامی طبیعت صادر و به آدرس شما پست خواهد شد.\nدرصورت نقص مدارک بصورت پیامک یا ایمیل به اطلاع شما خواهد رسید تا نسبت به رفع نقص اقدام کنید."
          });
          break;
        case 'aid':
          setText({
            for: "پرداخت ماهیانه",
            title: "از حمایت شما سپاسگزاریم!",
            description: "مبلغ اهدایی با موفقیت دریافت شد."
          });
          break;
        case 'order':
          setBackAppDo("restart");

          setText({
            for: "هزینه سفارش",
            title: "هزینه سفارش شما با شناسه " + match.params.param5 + " با موفقیت پرداخت شد.",
            description: "محصولات بزودی ارسال خواهد شد."
          });
          break;
        case 'event':
          setText({
            for: "هزینه سفر",
            title: "هزینه سفر با موفقیت پرداخت شد.",
            description: "برای هماهنگی بیشتر با شما تماس گرفته خواهد شد."
          });
          break;
      }
    }

    const initGraphics = () => {
      const winWidth = window.innerWidth
      const winHeight = window.innerHeight

      let bgWinRatio = winWidth / initBgWidth
      let bgWidth = initBgWidth * bgWinRatio
      let bgHeight = initBgHeight * bgWinRatio
      let bgLeft = 0
      let bgTop = ((winHeight / 2) - (bgHeight / 2))

      let contentLeft = 64 * bgWinRatio
      let contentTop = bgTop + (30 * bgWinRatio)
      let contentWidth = bgWidth - (contentLeft * 2)
      let contentHeight = bgHeight - (30 * bgWinRatio) - (20 * bgWinRatio)

      setBgSize({
        width: bgWidth + "px",
        height: bgHeight + "px",
        left: bgLeft + "px",
        top: bgTop + "px"
      })

      setContentSize({
        width: contentWidth + "px",
        height: contentHeight + "px",
        left: contentLeft + "px",
        top: contentTop + "px"
      })
    }

    initGraphics();
    initTexts();
  }, [])

  return <IonPage className="payment">
    {match.params.is_app != "1" ?
      <Toolbar2 hasBackButton transparent /> : null}

    <IonGrid>
      <IonRow>
        <IonCol>
          <IonImg className="receipt" src="/assets/images/payment/receipt.svg" style={{ left: bgSize.left, top: bgSize.top, width: bgSize.width, height: bgSize.height }} />

          <div className="content" style={{ left: contentSize.left, top: contentSize.top, width: contentSize.width, height: contentSize.height }}>
            <IonRow className="header">
              <IonCol>
                <h4 className="ion-no-margin">رسید تراکنش</h4>
              </IonCol>
            </IonRow>
            <IonRow className="heading-text">
              <IonCol>
                <IonText>{text.title}</IonText>
                <IonText className="desc">{text.description}</IonText>
              </IonCol>
            </IonRow>
            <IonRow className="ion-margin-top">
              <IonCol size="6" className="ion-text-right">
                <IonLabel className="title">بابت</IonLabel>
              </IonCol>
              <IonCol size="6" className="ion-text-left">
                <IonLabel className="value">{text.for}</IonLabel>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="6" className="ion-text-right">
                <IonLabel className="title">کد پیگیری</IonLabel>
              </IonCol>
              <IonCol size="6" className="ion-text-left">
                <IonLabel className="value">{decodeString(match.params.param2)}</IonLabel>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="6" className="ion-text-right">
                <IonLabel className="title">مبلغ پرداختی</IonLabel>
              </IonCol>
              <IonCol size="6" className="ion-text-left">
                <IonLabel className="value">{decodeString(match.params.param3)}</IonLabel>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="6" className="ion-text-right">
                <IonLabel className="title">تاریخ پرداخت</IonLabel>
              </IonCol>
              <IonCol size="6" className="ion-text-left">
                <IonLabel className="value"><div className="ltr">{decodeString(match.params.param4)}</div></IonLabel>
              </IonCol>
            </IonRow>
            <IonRow className="barcode">
              <IonCol>
                <svg ref={inputRef} />
              </IonCol>
            </IonRow>
          </div>
        </IonCol>
      </IonRow>
    </IonGrid>

    {
    match.params.is_app == "1" ?
      <div className="back-button">
        <BackAppButton doOnClick={backAppDo} />
      </div>
    : null
    }
  </IonPage>
}

export default Payment